import { useMainLayoutProvider } from "@providers/MainLayoutProvider/useMainLayoutProvider";

import { RecentUnresolvedNotificationsDropdown } from "@components/Dropdowns";
import { GlobalSearch } from "@components/GlobalSearch/GlobalSearch";

import { IconButton } from "@design-system/IconButton/IconButton";

import { useBreakpoint } from "@utils/hooks/useBreakpoint";

import classes from "./MainHeader.module.css";

export const MainHeader = () => {
  const { isSmallerThan } = useBreakpoint();
  const { toggleMobileNavigation, isFullWidth, toggleFullWidth } = useMainLayoutProvider();

  return (
    <header className={classes.header}>
      {isSmallerThan.laptop && (
        <IconButton icon="faBars" onClick={toggleMobileNavigation} />
      )}

      <div className={classes.search}>
        <GlobalSearch />
      </div>

      <div className={classes.actions}>
        <IconButton
          icon={isFullWidth ? "faCompress" : "faExpand"}
          onClick={toggleFullWidth}
          tooltip={isFullWidth ? "Compact view" : "Full width view"}
        />
        <RecentUnresolvedNotificationsDropdown count={5} />
      </div>
    </header>
  );
};
